import { IsEmail } from 'class-validator';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { UserApi } from '@intelingu/core/api/UserApi';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import Logger from '@intelingu/core/utils/Logger';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { SubmitButton } from '../../../partials/form/elements/SubmitButton';
import { Field } from '@intelingu/core/components/form/Field';
import { Form } from '@intelingu/core/components/form/Form';
import { TextInput } from '../../../partials/form/elements/TextInput';

export interface ResetPageProps {
    t?;
}

class ResetRequest {

    @IsEmail({}, {
        message: 'Email is invalid'
    })
    email: string;

}

@withTranslation(COMMON_NS)
@observer export class ResetPage extends Component<ResetPageProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(UserApi) userApi: UserApi;

    @observable isError = false;
    @observable isSent = false;

    @action.bound async reset(data: ResetRequest, done) {
        const { email } = data;

        try {
            this.isError = false;
            await this.userApi.reset({ email });

            this.isSent = true;
        } catch (e) {
            this.isError = true;

            Logger.error(e);
        } finally {
            done();
        }
    }

    render() {
        const { t } = this.props;

        return <div className={'session-page'}>
            { this.isSent && (
                <>
                    <div className={'alert alert-primary'}>
                        { t('resetPasswordInstructionsSent') }
                    </div>
                </>
            )}

            { !this.isSent && (
                <>
                    <h1>{ t('resetPasswordTitle') }</h1>

                    <p>
                        { t('resetPasswordEnterEmailText') }
                    </p>

                    <div className={'sep'} />

                    <Form validator={ResetRequest} onSubmit={this.reset}>
                        <FormGroup>
                            <Label for="email">{ t('sessionEmail') }</Label>

                            <Field
                                name={'email'}
                                render={props => <TextInput type={'email'} {...props} />}
                            />
                        </FormGroup>

                        { this.isError && (
                            <div className={'alert alert-danger'}>
                                { t('resetPasswordEmailNotFound') }
                            </div>
                        )}

                        <FormGroup style={{ marginTop: 20 }}>
                            <Field submit render={props => <SubmitButton className={'outline'} {...props}>{ t('resetPasswordButton') }</SubmitButton>} />
                        </FormGroup>
                    </Form>
                </>
            )}
        </div>
    }

}
